(() => {
  if (window.braapExploreReady) return;
  window.braapExploreReady = true;
  let request;
  const initialUrl = new URL(location.href);
  let currentDepartment = initialUrl.searchParams.get('department') || '', currentCategory = initialUrl.searchParams.get('category') || '';
  const specParam = name => 'bf.spec.' + name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  const canonicalFilterName = name => /^(?:size|sizer|helmet size)$/i.test(name.trim()) ? 'Size' : /^chain size$/i.test(name) ? 'Pitch' : name;
  const hiddenSidebarFilter = name => /^(?:manufacturer\s+part\b.*|mpn)$/i.test(name);
  const filterNameSort = (a, b) => a === 'Pitch' ? -1 : b === 'Pitch' ? 1 : a.localeCompare(b, undefined, {sensitivity:'base'});
  const customerProductType = card => {
    const explicit = String(card.dataset.productType || '').trim(); if (explicit) return explicit;
    const title = card.dataset.productTitle || '';
    const types = [['Helmets',/\bhelmet\b/i],['Goggles',/\bgoggle/i],['Gloves',/\bglove/i],['Boots & Footwear',/\bboot|shoe|footwear|sock/i],['Jerseys',/\bjersey\b/i],['Pants & Bibs',/\bpant|\bbib\b/i],['Jackets & Vests',/\bjacket|\bvest\b/i],['Shirts & Hoodies',/\bshirt|\btee\b|hoodie|sweatshirt/i],['Headwear',/\bhat\b|beanie|cap\b/i],['Tires',/\btire\b/i],['Wheels',/\bwheel\b|\brim\b/i],['Batteries',/\bbatter/i],['Brake Parts',/\bbrake|caliper|rotor/i],['Chains',/\bchain\b/i],['Sprockets',/\bsprocket/i],['Spark Plugs',/spark plug/i],['Filters',/\bfilter\b/i],['Controls & Levers',/\blever\b|handlebar|\bgrip\b|throttle/i],['Cables',/\bcable\b/i],['Clutch Parts',/\bclutch\b/i],['Exhaust',/\bexhaust|muffler|silencer|head pipe/i],['Body & Plastics',/\bplastic|fender|fairing|body kit/i],['Seats & Covers',/\bseat\b/i],['Lighting',/\blight|headlamp|headlight/i],['Bearings & Seals',/\bbearing|\bseal kit/i],['Gaskets',/\bgasket/i],['Pistons',/\bpiston/i],['Tools',/\btool\b|wrench|socket|plier/i]];
    return types.find(([, pattern]) => pattern.test(title))?.[0] || '';
  };
  const catalogPageCount = root => {
    const numbers = [...root.querySelectorAll('.approved-pagination a[href]')].map(link => Number(new URL(link.href, location.origin).searchParams.get('page')) || 1);
    const stated = root.querySelector('.approved-pagination')?.textContent.match(/page\s+\d+\s+of\s+(\d+)/i);
    return Math.max(1, Number(stated?.[1]) || 1, ...numbers);
  };
  const fetchCatalogPages = async (root, source) => {
    const total = catalogPageCount(root), documents = new Array(Math.max(0, total - 1)), section = root.dataset.catalogSection || 'braap-explore-catalog';
    if (total < 2) return documents;
    let nextPage = 2;
    const worker = async () => { while (nextPage <= total) { const pageNumber = nextPage++, url = new URL(source); url.searchParams.set('page', String(pageNumber)); url.searchParams.set('section_id', section); try { const response = await fetch(url); if (response.ok) documents[pageNumber - 2] = new DOMParser().parseFromString(await response.text(), 'text/html'); } catch {} } };
    await Promise.all(Array.from({length:Math.min(4, total - 1)}, worker));
    return documents.filter(Boolean);
  };
/* braap-same-variant-v1 */
const matchCardVariant = (card, optionSelections, specSelections) => {
  const priceParams=new URL(location.href).searchParams,min=priceParams.get('filter.v.price.gte'),max=priceParams.get('filter.v.price.lte');
  if (!optionSelections.length && !specSelections.length && !min && !max) return true;
  let variants, names;
  try { variants = JSON.parse(card.dataset.productVariants); names = JSON.parse(card.dataset.productOptions); } catch { return false; }
  if (!Array.isArray(variants) || !Array.isArray(names)) return false;
  const matches = variants.filter(variant => {
    if(min && variant.price/100<Number(min) || max && variant.price/100>Number(max))return false;
    const options = names.map((option, index) => ({name:option.name, values:[variant.options[index]]}));
    const values = new Map(options.map(option => [canonicalFilterName(option.name), new Set(option.values)]));
    if (!optionSelections.every(group => group.values.some(value => values.get(group.name)?.has(value)))) return false;
    const evidence = {dataset:{...card.dataset, productOptions:JSON.stringify(options), productTags:'[]'}};
    const specs = productSpecs(evidence);
    const variantSpecs = productSpecs({dataset:{...evidence.dataset,productTitle:''}});
    for (const name of ['Finish','Material','Pitch','Tooth Count']) if (variantSpecs.has(name)) specs.set(name,variantSpecs.get(name));
    return specSelections.every(group => group.values.some(value => specs.get(group.name)?.has(value)));
  });
  if (!matches.length) return false;
  const isChain=/\bchains?\b/i.test(card.dataset.productTitle||'')&&!/\b(guide|guard|slider|adjuster|tensioner|tool|lube|cleaner)s?\b/i.test(card.dataset.productTitle||'');
  const gold=isChain?matches.filter(item=>/\b(gold|gld)\b/i.test(item.title)&&item.featured_image?.src):[];
  const variant = gold.find(item=>item.available)||gold[0]||matches.find(item => item.available) || matches[0];
  const url = new URL(card.dataset.productUrl, location.origin); url.searchParams.set('variant', variant.id);
  card.querySelectorAll('[data-card-product-link]').forEach(link => {link.href=url.href;});
  const image = card.querySelector('.product-card-image');
  if (image && variant.featured_image?.src) {image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=variant.featured_image.src;image.alt=card.dataset.productTitle+' — '+variant.title;}
  const price = card.querySelector('[data-card-price]');
  if (price) price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(variant.price/100);
  let label=card.querySelector('[data-filter-matched-variant]');
  if (!label) {label=document.createElement('div');label.dataset.filterMatchedVariant='';(price?.parentElement||card).append(label);}
  label.textContent=variant.title==='Default Title'?'':variant.title;
  card.querySelectorAll('.product-color-thumbnail').forEach(button=>{const id=new URL(button.dataset.variantUrl,location.origin).searchParams.get('variant');button.hidden=!matches.some(item=>String(item.id)===id);button.setAttribute('aria-pressed',String(id===String(variant.id)));});
  return true;
};

  const productSpecs = card => {
    let tags = [], rawOptions = [];
    try { tags = JSON.parse(card.dataset.productTags || '[]'); } catch {}
    try { rawOptions = JSON.parse(card.dataset.productOptions || '[]'); } catch {}
    const optionText = rawOptions.flatMap(option => (option.values || []).map(value => typeof value === 'string' ? value : (value.name || value.value || ''))).join(' ');
    const text = [card.dataset.productTitle, optionText].join(' '), specs = new Map();
    const add = (name, value) => { if (!value) return; const values = specs.get(name) || new Set(); values.add(value); specs.set(name, values); };
    if (/chain|sprocket/i.test(currentCategory)) {
      for (const match of (rawOptions.filter(o=>/^(?:pitch|chain size)$/i.test(o.name)).flatMap(o=>o.values).join(' ') || (/\b(?:415|420|425|428H?|520|525|530|532|630)(?=\D|$)/i.test(optionText)?optionText:String(card.dataset.productTitle||''))).matchAll(/(?:^|[^0-9])(415|420|425|428H?|520|525|530|532|630)(?=$|[^0-9])/gi)) add('Pitch', match[1].toUpperCase());
      for (const match of text.matchAll(/(?:^|[^0-9])(\d{2,3})\s*(?:T|TOOTH|TEETH)(?=$|[^A-Z0-9])/gi)) add('Tooth Count', match[1] + ' Tooth');
    }
    if (/chain/i.test(currentCategory)) { if (/\bnon[- ]?o[- ]?ring\b/i.test(text)) add('Seal Type', 'Non-O-Ring'); else if (/\bo[- ]?ring\b/i.test(text)) add('Seal Type', 'O-Ring'); if (/\bx[- ]?ring\b/i.test(text)) add('Seal Type', 'X-Ring'); }
    if (/sprocket/i.test(currentCategory)) { if (/\bfront\b/i.test(text)) add('Position', 'Front'); if (/\brear\b/i.test(text)) add('Position', 'Rear'); }
    [['Stainless Steel',/\bstainless(?: steel)?\b/i],['Titanium',/\btitanium\b|\bti[- ]/i],['Aluminum',/\balum(?:inum|inium)?\b|\bbillet aluminum\b|\balu\b/i],['Carbon Fiber',/\bcarbon fiber\b/i],['Chromoly',/\bchromo?ly\b|\bchrome[- ]moly\b/i],['Brass',/\bbrass\b/i],['Copper',/\bcopper\b/i],['Plastic / Polymer',/\bplastic\b|\bpolymer\b/i],['Rubber',/\brubber\b/i],['Steel',/\bsteel\b|\bstl\b/i]].forEach(([value,re]) => { if (re.test(text) && !(value === 'Steel' && /\bstainless(?: steel)?\b/i.test(text))) add('Material', value); });
    [['Anodized',/\banodized\b/i],['Powder Coated',/\bpowder[- ]?coat(?:ed)?\b/i],['Polished',/\bpolished\b/i],['Chrome',/\bchrome(?: plated)?\b/i],['Nickel Plated',/\bnickel(?: plated)?\b/i],['Zinc Plated',/\bzinc(?: plated)?\b/i],['Matte',/\bmatte\b/i],['Gloss',/\bgloss(?:y)?\b/i],['Black',/\bblack\b|\bblk\b/i],['Gold',/\bgold\b|\bgld\b/i],['Silver',/\bsilver\b|\bsil\b|\bslv\b/i],['Natural',/\bnatural\b|\bnat\b/i],['Raw',/\braw\b/i]].forEach(([value,re]) => { if (re.test(text)) add('Finish', value); });
    return specs;
  };
  function syncFinderState(root) {
    const closeoutFilters = root.querySelector('[data-closeout-search-filters]');
    if (closeoutFilters) {
      closeoutFilters.action = location.href;
      const selected = new URL(location.href).searchParams.getAll('filter.p.vendor');
      closeoutFilters.querySelectorAll('input[name="filter.p.vendor"]').forEach(input => { input.checked = selected.includes(input.value); });
    }

    root.querySelectorAll('[data-product-type-form]').forEach(form => { form.action = new URL(location.href).href; form.hidden = !form.querySelector('input'); });
    const brandForm = root.querySelector('[data-closeout-brand-form]');
    if (brandForm) {
      const activeUrl = new URL(root.dataset.catalogUrl || location.href, location.origin);
      if (!activeUrl.search && location.pathname === activeUrl.pathname) activeUrl.search = location.search;
      brandForm.action = activeUrl.href;
      const select = brandForm.querySelector('select');
      select.value = activeUrl.searchParams.get('filter.p.vendor') || '';
    }

    const sidebar = root.querySelector('.bf-explore-sidebar');
    const sections = sidebar?.querySelector('.bf-smart-finder-sections');
    const categoryPanel = sidebar?.querySelector('[data-catalog-category-nav]');
    const refinePanel = sidebar?.querySelector('[data-catalog-refine]');
    if (!sidebar || !sections || !categoryPanel || !refinePanel) return;
    const title = sidebar.querySelector('[data-finder-title]');
    const help = sidebar.querySelector('[data-finder-help]');
    const departmentStep = sidebar.querySelector('[data-finder-step="department"]');
    const categoryStep = sidebar.querySelector('[data-finder-step="category"]');
    const filterStep = sidebar.querySelector('[data-finder-step="filters"]');
    [departmentStep, categoryStep, filterStep].forEach(step => { step?.removeAttribute('aria-current'); step?.removeAttribute('data-complete'); });
    if (!currentDepartment) {
      if (title) title.textContent = 'Start with what you ride';
      if (help) help.textContent = 'Choose a department, then a category. The useful filters will appear when they can actually help.';
      departmentStep?.setAttribute('aria-current', 'step');
      categoryPanel.querySelector(':scope > summary').textContent = '1 · CHOOSE DEPARTMENT';
      categoryPanel.open = true;
      refinePanel.hidden = true;
      sections.prepend(categoryPanel);
      return;
    }
    departmentStep?.setAttribute('data-complete', 'true');
    if (!currentCategory) {
      if (title) title.textContent = `Choose a ${window.BraapNavigation?.departmentLabel(currentDepartment) || 'product'} category`;
      if (help) help.textContent = 'Pick the closest category so the next step only shows filters that apply to those products.';
      categoryStep?.setAttribute('aria-current', 'step');
      categoryPanel.querySelector(':scope > summary').textContent = '2 · CHOOSE CATEGORY';
      categoryPanel.open = true;
      refinePanel.hidden = true;
      sections.prepend(categoryPanel);
      return;
    }
    categoryStep?.setAttribute('data-complete', 'true');
    filterStep?.setAttribute('aria-current', 'step');
    if (title) title.textContent = window.BraapNavigation?.categoryLabel(currentDepartment, currentCategory) || currentCategory;
    if (help) help.textContent = 'Now refine these results by the options available for this category.';
    categoryPanel.querySelector(':scope > summary').textContent = 'CHANGE CATEGORY';
    categoryPanel.open = false;
    refinePanel.hidden = false;
    refinePanel.open = true;
    sections.prepend(refinePanel);
  }
  function restoreSidebar(root) {
    const nav = window.BraapNavigation;
    if (!nav) return;
    return nav.ready.then(() => {
      const target = root.querySelector('[data-catalog-departments]');
      if (!target) return;
      const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const scope = root.dataset.catalogScope;
      const tags = new Set(JSON.parse(root.dataset.catalogTags || '[]'));
      const scopedRoute = href => {
        const url = new URL(href, location.origin);
        if (!scope) return url.href;
        const tag = decodeURIComponent(url.pathname.split('/').slice(3).join('/'));
        if (tag && !tags.has(tag)) return null;
        url.pathname = scope + (tag ? '/' + encodeURIComponent(tag) : '');
        return url.href;
      };
      const link = key => { const href = scopedRoute(nav.href(key)); return href ? `<a data-catalog-link href="${esc(href)}" aria-pressed="${key === currentDepartment}">${esc(key ? nav.departmentLabel(key) : scope ? 'All closeouts' : 'All Categories')}</a>` : ''; };
      const directoryHtml = link('') + nav.departmentSections.map(section => `<section class="directory-departments"><h3>${esc(section.label)}</h3>${section.keys.filter(key => nav.groups(key).length).map(link).join('')}</section>`).join('');
      target.replaceChildren();
      if (currentDepartment) {
        const refinements = document.createElement('div');
        refinements.className = 'catalog-refinements';
        refinements.innerHTML = `<h3>Refine ${esc(nav.departmentLabel(currentDepartment))}</h3>`;
        nav.directorySections(currentDepartment).forEach(section => {
          const heading = section.querySelector(':scope > h3');
          const groupName = heading?.textContent.trim() || 'More categories';
          heading?.remove();
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = groupName;
          details.append(summary);
          let active = false;
          section.querySelectorAll('a').forEach(categoryLink => {
            const href = scopedRoute(categoryLink.href);
            if (!href) return;
            categoryLink.href = href;
            categoryLink.dataset.catalogLink = '';
            const route = new URL(categoryLink.href, location.href).searchParams;
            if (currentCategory && route.get('category') === currentCategory) {
              categoryLink.setAttribute('aria-current', 'page');
              active = true;
            }
            details.append(categoryLink);
          });
          if (active) details.open = true;
          if (details.querySelector('a')) refinements.append(details);
        });
        const switcher = document.createElement('details');
        switcher.className = 'catalog-department-switcher';
        switcher.innerHTML = `<summary>Change department</summary><div class="catalog-department-switcher__body">${directoryHtml}</div>`;
        target.append(refinements, switcher);
      } else target.innerHTML = directoryHtml;
      target.querySelectorAll('.directory-departments').forEach(section => { if (!section.querySelector('a')) section.remove(); });
      syncFinderState(root);
    });
  }
  async function hydrateTechnicalCategory(root) {
    const source = new URL(root.dataset.catalogUrl || location.href, location.origin);
    const hasClientFilter = [...source.searchParams.keys()].some(key => key.startsWith('bf.')); // Native vendor filtering is already performed by Shopify.
    if (!/chain|sprocket/i.test(currentCategory) && !hasClientFilter) return;
    const cardUrl = card => card.dataset.productUrl || card.querySelector('[data-card-product-link]')?.href || '';
    const grid = root.querySelector('.bf-explore-grid'), seen = new Set([...root.querySelectorAll('.product-card')].map(cardUrl));
    const pages = grid ? await fetchCatalogPages(root, source) : [];
    pages.forEach(page => page.querySelectorAll('.bf-explore-grid > li').forEach(item => { const card = item.querySelector('.product-card'), url = card && cardUrl(card); if (card && !seen.has(url)) { seen.add(url); grid.append(item); } }));
    if (pages.length) {
      root.querySelector('.approved-pagination')?.remove();
      root.dataset.allPagesHydrated = 'true';
    }
  }
  async function allCategoryBrands(root) {
    const counts = new Map(), products = new Set(), base = new URL(root.dataset.catalogUrl || location.href, location.origin);
    if (root.dataset.allPagesHydrated === 'true') {
      root.querySelectorAll('.product-card[data-product-vendor]').forEach(card => {
        const vendor = card.dataset.productVendor, product = card.dataset.productUrl || card.querySelector('[data-card-product-link]')?.href || `${vendor}:${card.dataset.productTitle || ''}`;
        if (vendor && !products.has(product)) { products.add(product); counts.set(vendor, (counts.get(vendor) || 0) + 1); }
      });
      return counts;
    }
    [...base.searchParams.keys()].forEach(key => { if (key === 'page' || key === 'sort_by' || key.startsWith('filter.') || key.startsWith('bf.')) base.searchParams.delete(key); });
    const collect = scope => scope.querySelectorAll('.product-card[data-product-vendor]').forEach(card => {
      const vendor = card.dataset.productVendor, product = card.dataset.productUrl || card.querySelector('[data-card-product-link]')?.href || `${vendor}:${card.dataset.productTitle || ''}`;
      if (vendor && !products.has(product)) { products.add(product); counts.set(vendor, (counts.get(vendor) || 0) + 1); }
    });
    collect(root); (await fetchCatalogPages(root, base)).forEach(collect);
    return counts;
  }
  async function buildProductFilters(root) {
    const form = root.querySelector('[data-catalog-filter-form]');
    const brandArea = form?.querySelector('[data-catalog-brand-filter]');
    const dynamicArea = form?.querySelector('[data-catalog-dynamic-filters]');
    let cards = [...root.querySelectorAll('.product-card[data-product-vendor]')];
    const source = new URL(root.dataset.catalogUrl || location.href, location.origin), query = source.searchParams;
    const currentTypes = query.getAll('bf.product_type');
    if (/chain/i.test(currentCategory)) {
      cards = cards.filter(card => {
        if (!/\baxle blocks?\b/i.test(card.dataset.productTitle || '')) return true;
        card.closest('li')?.remove();
        return false;
      });
    }
    if (!form || !brandArea || !dynamicArea || !cards.length || (!currentCategory && !query.getAll('filter.p.vendor').length && !currentTypes.length)) return;
    const display = value => value.replace(/100(?:-|\s)Percent/gi, '100%');
    const vendorFacets = [...brandArea.querySelectorAll('[data-vendor-facet]')].map(node => ({value:node.dataset.value, label:node.dataset.label || node.dataset.value, count:Number(node.dataset.count) || 0, active:node.dataset.active === 'true'}));
    const checkbox = (name, value, count, checked) => {
      const label = document.createElement('label'), input = document.createElement('input'), text = document.createElement('span'), number = document.createElement('span');
      label.className = 'filter-option'; input.type = 'checkbox'; input.name = name; input.value = value; input.checked = checked; input.dataset.clientFilter = '';
      text.className = 'filter-label'; text.textContent = display(value); number.className = 'filter-count'; number.textContent = count;
      label.append(input, text, number); return label;
    };
    const vendors = await allCategoryBrands(root);
    vendorFacets.forEach(row => { if (!vendors.has(row.value)) vendors.set(row.value, row.count); });
    if (!vendors.size) cards.forEach(card => { const value = card.dataset.productVendor; if (value) vendors.set(value, (vendors.get(value) || 0) + 1); });
    query.getAll('filter.p.vendor').forEach(value => { if (value && !vendors.has(value)) vendors.set(value, 0); });
    brandArea.replaceChildren(...[...vendors].sort(([a], [b]) => display(a).localeCompare(display(b), undefined, {sensitivity:'base'})).map(([value, count]) => checkbox('filter.p.vendor', value, count, query.getAll('filter.p.vendor').includes(value))));

    const optionGroups = new Map(), cardOptions = new Map(), specGroups = new Map(), cardSpecs = new Map(), ageCounts = new Map(), fitCounts = new Map(), cardAges = new Map(), cardFits = new Map(), typeCounts = new Map(), cardTypes = new Map();
    cards.forEach(card => {
      const productType = customerProductType(card);
      cardTypes.set(card, productType);
      if (productType) typeCounts.set(productType, (typeCounts.get(productType) || 0) + 1);
      let options = [], tags = [];
      try { options = JSON.parse(card.dataset.productOptions || '[]'); } catch {}
      try { tags = JSON.parse(card.dataset.productTags || '[]'); } catch {}
      const normalized = new Map();
      options.forEach(option => {
        const rawName = String(option.name || '').trim(); if (!rawName || /^(?:title|configuration)$/i.test(rawName) || hiddenSidebarFilter(rawName)) return;
        const name = canonicalFilterName(rawName), group = optionGroups.get(name) || new Map(), values = normalized.get(name) || new Set();
        (option.values || []).forEach(raw => { const value = String(typeof raw === 'string' ? raw : (raw.name || raw.value || '')).trim(); if (!value || /^default title$/i.test(value) || values.has(value)) return; values.add(value); group.set(value, (group.get(value) || 0) + 1); });
        if (group.size) { optionGroups.set(name, group); normalized.set(name,new Set([...(normalized.get(name)||[]),...values])); }
      });
      cardOptions.set(card, normalized);
      const specs = productSpecs(card); cardSpecs.set(card, specs);
      specs.forEach((values, name) => { const counts = specGroups.get(name) || new Map(); values.forEach(value => counts.set(value, (counts.get(value) || 0) + 1)); specGroups.set(name, counts); });
      const optionText = [...normalized.values()].flatMap(values => [...values]).join(' '), text = [card.dataset.productTitle, ...tags, optionText].join(' '), tagText = tags.join(' '), ages = new Set(), fits = new Set();
      if (/\brider[-_: ]?youth\b/i.test(tagText)) ages.add('Youth');
      if (/\brider[-_: ]?adult\b/i.test(tagText)) ages.add('Adult');
      if (/\bfit[-_: ]?men\b/i.test(tagText)) fits.add('Men');
      if (/\bfit[-_: ]?women\b/i.test(tagText)) fits.add('Women');
      if (/\bfit[-_: ]?unisex\b/i.test(tagText)) fits.add('Unisex');
      if (!ages.size && /\b6d\b/i.test(text)) {
        if (/\bATR[- ]?(?:2Y|3Y)\b/i.test(text)) ages.add('Youth');
        else if (/\bATR[- ]?(?:1|2|3|3X)\b/i.test(text)) ages.add('Adult');
      }
      if (!ages.size) ages.add(/\b(youth|youths|kid|kids|child|children|junior|jr)\b/i.test(text) ? 'Youth' : 'Adult');
      if (!fits.size) { if (/\b(women(?:'s)?|ladies|female|girls?)\b/i.test(text)) fits.add('Women'); else if (/\b(men(?:'s)?|male|boys?)\b/i.test(text)) fits.add('Men'); else fits.add('Unisex'); }
      ages.forEach(value => ageCounts.set(value, (ageCounts.get(value) || 0) + 1)); fits.forEach(value => fitCounts.set(value, (fitCounts.get(value) || 0) + 1)); cardAges.set(card, ages); cardFits.set(card, fits);
    });

 /* braap-scoped-facets-v1 */
 // Rebuild option/spec choices from the selected product type and audience.
 optionGroups.clear(); specGroups.clear();
 const facetBrands=query.getAll('filter.p.vendor'),facetAges=query.getAll('bf.age'),facetFits=query.getAll('bf.fit');
 cards.forEach(card=>{
  if(currentTypes.length&&!currentTypes.includes(cardTypes.get(card)))return;
  if(facetBrands.length&&!facetBrands.includes(card.dataset.productVendor))return;
  if(facetAges.length&&!facetAges.some(v=>cardAges.get(card)?.has(v)))return;
  if(facetFits.length&&!facetFits.some(v=>cardFits.get(card)?.has(v)))return;
  for(const [values,groups] of [[cardOptions.get(card),optionGroups],[cardSpecs.get(card),specGroups]])
   values?.forEach((items,name)=>{const counts=groups.get(name)||new Map();items.forEach(value=>counts.set(value,(counts.get(value)||0)+1));groups.set(name,counts)});
 });
 for(const prefix of ['filter.v.option.','bf.option.']){
  for(const alias of ['helmet_size','sizer']){
   const key=prefix+alias;
   query.getAll(key).forEach(value=>{if(optionGroups.get('Size')?.has(value)&&!query.getAll(prefix+'size').includes(value))query.append(prefix+'size',value)});
   query.delete(key);
  }
 }
 // A native option facet and a generated facet must not both be shown.
 form.querySelectorAll('fieldset').forEach(field=>{
  if(field.closest('.variant-filter-groups')||field.closest('[data-catalog-dynamic-filters]'))return;
  const input=field.querySelector('input[name^="filter.v.option."]');
  if(input&&optionGroups.has(canonicalFilterName(field.querySelector('legend')?.textContent.trim()||'')))field.remove();
 });
    const productTypeForm = root.querySelector('[data-product-type-form]');
    if (productTypeForm && root.querySelector('[data-closeout-brand-form]') && (typeCounts.size > 1 || currentTypes.length)) {
      const fieldset = document.createElement('fieldset'), legend = document.createElement('legend'), list = document.createElement('div');
      legend.textContent = 'Product type'; list.className = 'workshop-filter-list';
      [...typeCounts].sort(([a], [b]) => a.localeCompare(b, undefined, {sensitivity:'base'})).forEach(([value, count]) => list.append(checkbox('bf.product_type', value, count, currentTypes.includes(value))));
      fieldset.append(legend, list); productTypeForm.replaceChildren(fieldset); productTypeForm.hidden = false;
    }
    dynamicArea.replaceChildren();
    const addGroup = (legendText, name, values, optionName, specName) => {
      const fieldset = document.createElement('fieldset'), legend = document.createElement('legend'), list = document.createElement('div');
      fieldset.className = optionName ? 'variant-option-filter' : specName ? 'technical-spec-filter' : 'rider-type-filter'; legend.textContent = legendText; list.className = 'workshop-filter-list';
      if (optionName) fieldset.dataset.optionName = optionName;
      if (specName) fieldset.dataset.specName = specName;
      [...values].sort(([a], [b]) => a.localeCompare(b, undefined, {numeric:true, sensitivity:'base'})).forEach(([value, count]) => list.append(checkbox(name, value, count, query.getAll(name).includes(value))));
      fieldset.append(legend, list); dynamicArea.append(fieldset);
    };
    const pitchSpec = specGroups.get('Pitch'), pitchOption = optionGroups.get('Pitch');
    if (typeCounts.size > 1 || currentTypes.length) addGroup('Product type', 'bf.product_type', typeCounts);
    if (pitchSpec) addGroup('Pitch', specParam('Pitch'), pitchSpec, null, 'Pitch');
    else if (pitchOption) addGroup('Pitch', 'bf.option.pitch', pitchOption, 'Pitch');
    if (ageCounts.size > 1) addGroup('Age Group', 'bf.age', ageCounts);
    if (fitCounts.size > 1) addGroup('Fit', 'bf.fit', fitCounts);
    [...specGroups].filter(([name]) => name !== 'Pitch').sort(([a], [b]) => filterNameSort(a, b)).forEach(([name, values]) => { if (values.size > 1) addGroup(name, specParam(name), values, null, name); });
    [...optionGroups].filter(([name]) => name !== 'Pitch').sort(([a], [b]) => filterNameSort(a, b)).forEach(([name, values]) => addGroup(name, 'bf.option.' + name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''), values, name));
    const status = root.querySelector('[data-catalog-status]'); if (status && !status.dataset.baseStatus) status.dataset.baseStatus = status.textContent.trim();
    root.applyWorkshopFilters = () => {
      const selectedBrands = [...form.querySelectorAll('input[name="filter.p.vendor"]:checked')].map(input => input.value), selectedTypes = [...form.querySelectorAll('input[name="bf.product_type"]:checked')].map(input => input.value), selectedAges = [...form.querySelectorAll('input[name="bf.age"]:checked')].map(input => input.value), selectedFits = [...form.querySelectorAll('input[name="bf.fit"]:checked')].map(input => input.value);
      const optionSelections = [...form.querySelectorAll('.variant-option-filter')].map(fieldset => ({name:fieldset.dataset.optionName, values:[...fieldset.querySelectorAll('input:checked')].map(input => input.value)})).filter(group => group.values.length), specSelections = [...form.querySelectorAll('.technical-spec-filter')].map(fieldset => ({name:fieldset.dataset.specName, values:[...fieldset.querySelectorAll('input:checked')].map(input => input.value)})).filter(group => group.values.length);
      let visible = 0;
      cards.forEach(card => { const brandMatch = !selectedBrands.length || selectedBrands.includes(card.dataset.productVendor), typeMatch = !selectedTypes.length || selectedTypes.includes(cardTypes.get(card)), ageMatch = !selectedAges.length || selectedAges.some(value => cardAges.get(card)?.has(value)), fitMatch = !selectedFits.length || selectedFits.some(value => cardFits.get(card)?.has(value)), options = cardOptions.get(card) || new Map(), optionMatch = optionSelections.every(group => group.values.some(value => options.get(group.name)?.has(value))), specs = cardSpecs.get(card) || new Map(), specMatch = specSelections.every(group => group.values.some(value => specs.get(group.name)?.has(value))), show = brandMatch && typeMatch && ageMatch && fitMatch && matchCardVariant(card,optionSelections,specSelections); card.closest('li').hidden = !show; if (show) visible++; });
      const active = selectedBrands.length || selectedTypes.length || selectedAges.length || selectedFits.length || optionSelections.length || specSelections.length;
      if (status) status.textContent = active ? `${visible} ${visible === 1 ? 'product' : 'products'} shown` : status.dataset.baseStatus;
    };
    root.applyWorkshopFilters();
  }
  const initial = document.querySelector('.bf-explore');
  if (initial) { syncFinderState(initial); restoreSidebar(initial); hydrateTechnicalCategory(initial).then(() => buildProductFilters(initial)); }
  async function loadCatalog(root, destination) {
    if (request) request.abort();
    request = new AbortController();
    const activeRequest = request;
    const url = new URL(destination, location.origin);
    if (url.origin !== location.origin) return;
    const fallback = new URL(url);
    url.searchParams.set('section_id', root.dataset.catalogSection || 'braap-explore-catalog');
    root.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, {signal: request.signal});
      if (!response.ok) throw new Error('Catalog unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('.bf-explore');
      if (!next) throw new Error('Catalog unavailable');
      const requestedTag = fallback.pathname.split('/').find(part => part.startsWith('bfnav-'));
      const activeTags = JSON.parse(next.dataset.activeTags || 'null') || [];
      if (requestedTag && !activeTags.includes(requestedTag)) {
        next.querySelector('.bf-explore-grid').replaceChildren();
        next.querySelector('.approved-pagination')?.remove();
        next.querySelector('[data-catalog-status]').textContent = 'This department is still being connected to the Shopify catalog. Browse all products while the transfer is completed.';
      }
      currentDepartment = fallback.searchParams.get('department') || '';
      if (fallback.searchParams.get('group') === 'Chemicals & Lubes') currentDepartment = 'Chemicals';
      currentCategory = fallback.searchParams.get('category') || '';
      const forms = next.querySelectorAll('[data-catalog-form]');
      fallback.searchParams.delete('section_id');
      fallback.searchParams.delete('page');
      next.dataset.catalogUrl = fallback.href;
      forms.forEach(form => { form.action = fallback.href; });
      next.querySelectorAll('.approved-pagination a').forEach(link => {
        const paging = new URL(link.href);
        ['department', 'category', 'group'].forEach(key => {
          if (fallback.searchParams.has(key)) paging.searchParams.set(key, fallback.searchParams.get(key));
        });
        link.href = paging.href;
      });
      // braap-atomic-catalog-transition: keep current controls until replacements are ready.
      syncFinderState(next);
      await restoreSidebar(next);
      await hydrateTechnicalCategory(next);
      await buildProductFilters(next);
      if (activeRequest !== request || activeRequest.signal.aborted) return;
      root.replaceWith(next);
      history.pushState({braapCatalog:true}, '', fallback.pathname + fallback.search + fallback.hash);
      const heading = next.querySelector('h2');
      heading.tabIndex = -1;
      heading.focus({preventScroll: true});
    } catch (error) {
      if (error.name === 'AbortError') return;
      root.removeAttribute('aria-busy');
      const status = root.querySelector('[data-catalog-status]');
      status.textContent = 'Could not load the catalog. ';
      const link = document.createElement('a');
      link.href = fallback.href; link.textContent = 'Open this collection';
      status.append(link);
    }
  }
  document.addEventListener('click', event => {
    const filterToggle = event.target.closest('[data-catalog-filter-toggle]');
    if (filterToggle) {
      const root = filterToggle.closest('.bf-explore'), sidebar = root?.querySelector('.bf-explore-sidebar');
      if (!sidebar) return;
      const expanded = filterToggle.getAttribute('aria-expanded') !== 'true';
      filterToggle.setAttribute('aria-expanded', String(expanded));
      sidebar.classList.toggle('is-mobile-open', expanded);
      if (expanded) sidebar.scrollIntoView({block: 'nearest'});
      return;
    }
    const colorButton = event.target.closest('.product-color-thumbnail');
    if (colorButton) {
      const card = colorButton.closest('.product-card'), image = card?.querySelector('.product-card-image');
      card?.querySelectorAll('.product-color-thumbnail').forEach(item => item.setAttribute('aria-pressed', String(item === colorButton)));
      card?.querySelectorAll('[data-card-product-link]').forEach(link => { link.href = colorButton.dataset.variantUrl; });
      if (image && colorButton.dataset.imageSrc) {
        image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = colorButton.dataset.imageSrc;
        image.alt = (card.dataset.productTitle || 'Product') + ' — ' + colorButton.dataset.colorName;
      }
      const price = card?.querySelector('[data-card-price]'); if (price) price.textContent = colorButton.dataset.price || price.textContent;
      const stock = card?.querySelector('[data-card-stock]'); if (stock) { const available = colorButton.dataset.available === 'true'; stock.hidden = false; stock.textContent = available ? 'In stock' : 'Sold out'; stock.dataset.state = available ? 'in' : 'out'; }
      return;
    }
    const link = event.target.closest('[data-catalog-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
    const root = link.closest('.bf-explore');
    if (!root) return;
    event.preventDefault(); loadCatalog(root, link.href);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-nav-department]') && event.target.closest('.bf-explore')) loadCatalog(event.target.closest('.bf-explore'), window.BraapNavigation.href(event.target.value));
    if (event.target.matches('[data-closeout-brand-form] select')) {
      const form = event.target.form, root = form?.closest('.bf-explore'), url = new URL(location.href);
      url.searchParams.delete('filter.p.vendor');
      if (event.target.value) url.searchParams.set('filter.p.vendor', event.target.value);
      url.searchParams.delete('page');
      if (root) loadCatalog(root, url);
      return;
    }
    if (event.target.matches('[data-product-type-form] input')) {
      const root = event.target.closest('.bf-explore'), form = event.target.form, url = new URL(location.href);
      url.searchParams.delete('filter.p.product_type'); url.searchParams.delete('bf.product_type');
      new FormData(form).forEach((value,key) => url.searchParams.append(key,value));
      url.searchParams.delete('page'); loadCatalog(root,url); return;
    }
    if (event.target.matches('[data-client-filter]')) { event.target.closest('.bf-explore')?.applyWorkshopFilters?.(); return; }
    if (event.target.matches('[data-catalog-filter-form] input[type="checkbox"]')) {
      const form = event.target.closest('[data-catalog-filter-form]');
      const url = new URL(form.action);
      const data = new FormData(form);
      const keys = new Set([...form.elements].map(control => control.name).filter(Boolean));
      keys.forEach(key => url.searchParams.delete(key));
      for (const [key, value] of data) if (value) url.searchParams.append(key, value);
      url.searchParams.delete('page');
      loadCatalog(form.closest('.bf-explore'), url);
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-catalog-form]')) return;
    event.preventDefault();
    const url = new URL(event.target.action);
    const data = new FormData(event.target);
    const keys = new Set([...event.target.elements].map(control => control.name).filter(Boolean));
    keys.forEach(key => url.searchParams.delete(key));
    for (const [key, value] of data) if (value) url.searchParams.append(key, value);
    url.searchParams.delete('page');
    loadCatalog(event.target.closest('.bf-explore'), url);
  });
  window.addEventListener('popstate', () => {
    const root = document.querySelector('.bf-explore');
    if (root) loadCatalog(root, location.href);
  });
})();



